<div [hidden]="!!!(shouldFlyoutExist$ | async)">
  <div
    class="col-sm-3 col-md-3 col-lg-3 custom-gray-border"
    [style.top]="getTopMargin()"
    *ngIf="!isFlyoutDrawnOut"
    (click)="drawFlyout('out')"
  ></div>

  <div
    class="col-sm-3 col-md-3 col-lg-3 custom-multicountry-box"
    [ngClass]="{
      'custom-multicountry-box-aida': isAidaEnabled && unicornQuotas.length
    }"
    [style.top]="getTopMargin()"
    [hidden]="!isFlyoutDrawnOut"
  >
    <div
      class="col-sm-3 col-md-3 col-lg-3 custom-multicountry-in"
      (click)="drawFlyout('in')"
    ></div>

    <ng-container>
      <ps-ui-multi-country
        [surveyDetails]="surveyDetails"
        [surveyPayload]="surveyPayload"
        [countries]="countries"
        [selectedTemplateId]="selectedTemplateId"
        (selectionChange)="drawFlyout('in')"
        (mcSurveyAdded)="informOnMcSurveyAdded()"
        (whenMcDataPresent)="whenMcDataPresent($event)"
        (cancelTemplateSelection)="cancelTemplateSelection.emit($event)"
      ></ps-ui-multi-country>
    </ng-container>
  </div>
</div>
